import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, H5, Tabs } from '@parspec/pixel';
import { TAB_VALUES } from './utils/utils';


const TAB_OPTIONS = [
    { label: 'Account Details', value: TAB_VALUES.ACCOUNT_DETAILS },
    { label: 'Security', value: TAB_VALUES.SECURITY },
    { label: 'Preferences', value: TAB_VALUES.PREFERENCES }
];

const Header: FC = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tabValue = params?.get('tab');
    const navigate = useNavigate();

    useEffect(() => {
        if (!tabValue || !TAB_OPTIONS.find((tab) => tab.value === tabValue)) {
            handleTabChange(TAB_VALUES.ACCOUNT_DETAILS);
        }
    }, [params]);

    const handleTabChange = (tabValue: string) => {
        navigate({
            search: new URLSearchParams({ tab: tabValue }).toString()
        });
    };

    return (
        <Box px={4}>
            <H5>My Profile</H5>
            <Tabs onChange={handleTabChange} options={TAB_OPTIONS} selectedTab={tabValue || ''} />
        </Box>
    );
};

export default Header;
